var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.632,
    height: 12,
    viewBox: "0 0 12.632 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1d0e3d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.632,7.573l-4.541-.392L9.316,3,7.541,7.187,3,7.573,6.448,10.56,5.413,15l3.9-2.356L13.219,15l-1.029-4.44ZM9.316,11.463,6.941,12.9l.632-2.7-2.1-1.819,2.766-.24L9.316,5.589,10.4,8.141l2.766.24-2.1,1.819.632,2.7Z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default __webpack_public_path__ + "static/media/promotions.9420d093de3eb384ba096b40385a3f1c.svg";
export { ForwardRef as ReactComponent };